import Vue from "vue";
import SearchResult from "./SearchResult.vue";

export function load() {
    const selector = "search-result-listing-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(SearchResult, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
